module.exports = __webpack_public_path__ + "static/media/steve-ukulele.10d408e2.jpg";